import { DAY_PASCAL, DIRECTION } from '../../constants';
import { Week } from './types';
import { format } from 'date-fns';

const createWeekEntry = (
  weekStart: Date,
  weekEnd: Date,
  isSplit: boolean,
  numberOfDays: number,
  week: number,
  commencingDay: DAY_PASCAL,
  commencingWeek: Date,
  weekIndex: number,
  splitDirection?: DIRECTION,
  month?: number
): Week => ({
  weekStart: format(weekStart, 'dd-MM-yyyy'),
  weekEnd: format(weekEnd, 'dd-MM-yyyy'),
  commencingDay,
  commencingWeek: format(commencingWeek, 'dd-MM-yyyy'),
  month: month ?? weekStart.getMonth() + 1,
  weekIndex,
  isSplit,
  splitDirection,
  numberOfDays,
  week
});

export default createWeekEntry;
